"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("./utils");
var I18n_1 = require("./I18n");
var PoiMap_1 = require("./PoiMap");
if (document.querySelector('.js-poi-map')) {
    (0, PoiMap_1.initPoiMaps)(new I18n_1.I18n((0, utils_1.retrieveCurrentLanguage)()));
}
